import { render } from "./NotAllowedView.vue?vue&type=template&id=ac2fdd82"
import script from "./NotAllowedView.vue?vue&type=script&lang=js"
export * from "./NotAllowedView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__